import { css } from "@emotion/react";
import { MoonLoader } from "react-spinners";
import { themeColor } from "../../constant/color";
export const Button = ({
  bg,
  text,
  color,
  loading,
  loaderColor,
  loaderSize,
  onClick,
  height,
  border,
  btnStyles,
}) => {
  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;
  // console.log(loading, "process");
  return (
    <button
      onClick={onClick}
      disabled={loading}
      className={`w-full h-[40px] flex items-center justify-center cursor-pointer rounded  ${
        bg || "bg-gray-900"
      }`}
      style={{
        ...btnStyles,
        background: bg || themeColor.black,
        width: "100%",
        height: 40,
        border: border || "none",
      }}
    >
      {loading ? (
        <MoonLoader
          css={override}
          color={loaderColor || themeColor.white}
          size={loaderSize || 20}
          speedMultiplier={1}
        />
      ) : (
        <div
          className="font-light text-[14px]"
          style={{
            color: color || themeColor.white,
          }}
        >
          {text}
        </div>
      )}
    </button>
  );
};
